<button
  (click)="fileInput.click()"
  class="btn btn-primary">
  <i class="bi bi-file-earmark-arrow-up-fill"></i>
  Carica da PC
  <input [formControl]="backupFileControl" #fileInput type="file" (change)="upload($event)" style="display:none;" accept=".backup"/>
</button>
